import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from "@apollo/client";

import authLink from "../../../../modules/auth/authLink";

/**
 * The taxonomy API is a separate endpoint from the console's own GraphQL API
 * and takes no auth token, so this feature keeps its own client rather than
 * using the root ApolloProviderWithAuthToken.
 *
 * Deliberately not `modules/api/taxonomy.ts`: that client declares a
 * `Query.parameters` merge policy that appends incoming results to existing
 * ones, which would duplicate rows every time this feature refetches
 * ListParameters. It has no consumers today; if it gains any, the two should
 * be reconciled rather than merged blindly.
 */

const cache = new InMemoryCache(
    {
        typePolicies: {
            BimClass: {
                fields: {
                    metadata: {
                        merge(existing, incoming, { mergeObjects }) {
                            return mergeObjects(existing, incoming);
                        },
                    },
                },
                // Revisions of one BimClass share an id, so the revision has to
                // be part of the cache key or they overwrite each other.
                keyFields: [
                    "id",
                    "revisionID",
                ],
            },
        },
    }
);

export default new ApolloClient(
    {
        cache,
        link: ApolloLink.from([authLink(), new HttpLink({ uri: "https://api.bimproject.cloud/graphql" })]),
    },
);
